import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import {  map } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { environment } from '@environments/environment';
import { PreBillingBook } from '@classes/pre-billing/preBilling';
import moment from 'moment';
import { PreBillingGeneratePdfRequest } from '@classes/pre-billing/preBillingGeneratePdfRequest';
import { UiService } from './ui.service';
import { PreBillingHistory } from '@classes/pre-billing/preBillingHistory';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { Pagination } from '@classes/pagination/pagination';
import { start } from 'repl';

@Injectable({
  providedIn: 'root'
})
export class PreBillingService {
    private readonly baseUrl: string = environment.apiUrl + 'invoices';

    private lastPreBillingHistoryQueryObj: {
        site: null,
        range: {
        fromStartDate:null,
        toStartDate: null,
        }
    };

    preBillingHistoriesPaginationSubject = new BehaviorSubject<Pagination>(null);

    private preBillingBook: PreBillingBook;
    preBillingBookChanged = new Subject<PreBillingBook>();

    private preBillingHistories: PreBillingHistory[];
    preBillingHistoriesChanged = new Subject<PreBillingHistory[]>();

    constructor(
        private http: HttpClient,
        private uiSrv: UiService
    ) { }

    public getNew(siteId: string, startDate: Date, endDate: Date ): Observable<PreBillingBook> {
        const formatedStartDate = moment(new Date(startDate)).startOf('day').utc().format("YYYY-MM-DD HH:mm");
        const formatedEndDate = moment(new Date(endDate)).endOf('day').utc().format("YYYY-MM-DD HH:mm");

        return this.http.get<PreBillingBook>(`${this.baseUrl}/new?siteId=${siteId}&startDate=${formatedStartDate}&endDate=${formatedEndDate}`)
        .pipe(
            map(preBillingBook => {
                this.preBillingBook = PreBillingBook.fromObject(preBillingBook);
                this.preBillingBookChanged.next(this.preBillingBook);
                return this.preBillingBook;
            })
        );
    }

    public getHistory(request: PaginationRequest): Observable<PreBillingHistory[]> {
        this.uiSrv.loadingStateChanged.next(true);
        let httpParams = new HttpParams();

        if (request.pageSize && request.page) {
            httpParams = httpParams
                .append("pageSize", request.pageSize.toString())
                .append("page", request.query !== this.lastPreBillingHistoryQueryObj ? "1" : request.page.toString());
        }

        if(request.query){
            const filters = request.query;
            const filtersQuery = [];

            if (filters.range?.fromStartDate && filters.range?.toStartDate)  {
                const formatedStartDate = moment(new Date(filters.range.fromStartDate)).startOf('day').utc().format("YYYY-MM-DD HH:mm");
                const formatedEndDate = moment(new Date(filters.range.toStartDate)).endOf('day').utc().format("YYYY-MM-DD HH:mm");

                filtersQuery.push(`startDate>=${formatedStartDate}`);
                filtersQuery.push(`endDate<=${formatedEndDate}`);
            }

            if (filters.site) {
                filtersQuery.push(`siteId==${filters.site}`);
            }

            httpParams = httpParams.append("Filters", filtersQuery.join());
        }

        if (request.sort) {
            httpParams = httpParams.append("sorts", request.sort);
        }

    this.lastPreBillingHistoryQueryObj = request.query;

        return this.http.get(`${this.baseUrl}`, {params: httpParams, observe: 'response'})
        .pipe(
            map((result: HttpResponse<PreBillingHistory[]>) => {
                this.uiSrv.loadingStateChanged.next(false);
                const pagination: Pagination = JSON.parse(result.headers.get('X-Pagination'));
                this.preBillingHistories = result.body;
                this.preBillingHistoriesChanged.next(this.preBillingHistories);
                this.preBillingHistoriesPaginationSubject.next({ ...pagination });
                return this.preBillingHistories;
            })
        );
    }


  public generatePdf(preBillingGeneratePdfRequest: PreBillingGeneratePdfRequest): Observable<Blob>{
      this.uiSrv.loadingStateChanged.next(true);
      return this.http.post(`${this.baseUrl}/pdf`, preBillingGeneratePdfRequest,{ observe: 'response', responseType: "blob"} ) 
          .pipe(map(res => this.saveFile(res)));
  }

  public downloadPdf(id: string){
      this.uiSrv.loadingStateChanged.next(true);
      return this.http.get(`${environment.apiUrl}documents/${id}/file`,{ observe: 'response', responseType: "blob"} ) 
          .pipe(map(res => this.saveFile(res)));
  }

  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    this.uiSrv.loadingStateChanged.next(false);
    return res.body;
  }

  public deletePdf(history: PreBillingHistory){
        return this.http.delete(`${this.baseUrl}/${history.id}`)
        .pipe(
            map(() => {
                this.uiSrv.loadingStateChanged.next(false);
                this.preBillingHistories = this.preBillingHistories.filter(item => item.id !== history.id);
                this.preBillingHistoriesChanged.next(this.preBillingHistories);
                this.uiSrv.showSnackbar('Document supprimé avec succès', false);
                return this.preBillingHistories;
            })
        );
  }
}
